/* ============================================================
   BOLO TIE — B2 · PAGE DE COLLECTION · le script
   Repris de maquettes/collection-b2.html, reduit a ce qui reste
   une fois le filtre / tri / pagination rendus par Shopify (liens
   reels, page rechargee) :
     A · l'apparition echelonnee des cartes, de la tuile et des
         bandes a l'entree dans l'ecran — le SCRIPT pose l'etat
         masque (.anim) puis le leve (.in) ; sans JavaScript rien
         n'est jamais masque. LE FILET EST ARME : il ne revele TOUT
         a 1,1 s que si l'observateur n'a jamais repondu ; sinon il
         rattrape seulement ce qui est deja a l'ecran.
     B · le compteur du chapeau se compte a l'arrivee de la pastille
         (.lit est posee par le script de l'en-tete).
   Horizon : au-dessus de 990 px c'est .page-wrapper qui defile, on
   ecoute donc 'scroll' sur window ET sur le wrapper.
   ============================================================ */
(function(){
"use strict";
var REDUCED = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
function $(s,c){ return (c||document).querySelector(s); }
function $$(s,c){ return Array.prototype.slice.call((c||document).querySelectorAll(s)); }

/* ---- A · APPARITION ECHELONNEE ---- */
var items = $$("#grid .card, #grid .promo, #grid .ed");
var io = null, ioFired = false, safeT = 0, hardT = 0;

function reveal(t){
  if (!t || t.classList.contains("in")) return;
  t.classList.add("in");
  /* une fois revelee, .anim est retiree : le survol redevient instantane */
  setTimeout(function(){ t.classList.remove("anim"); }, 780);
}
function revealAll(){ $$("#grid .anim").forEach(reveal); }
function revealInView(){
  var h = window.innerHeight || document.documentElement.clientHeight || 0;
  var l = $$("#grid .anim:not(.in)");
  for (var i=0;i<l.length;i++){
    var r = l[i].getBoundingClientRect();
    /* seuil VOLONTAIREMENT plus tardif que celui de l'observateur : en
       marche normale il ne trouve rien ; il ne sert que si l'observateur
       est mort ou gele. */
    if (r.bottom > -1 && r.top < h * 0.55) reveal(l[i]);
  }
}
/* le filet : si l'observateur n'a JAMAIS repondu au bout de 1,1 s on revele
   tout ; s'il a repondu, on se contente de rattraper ce qui est a l'ecran —
   le reste garde son apparition pour le moment ou on y arrive. */
function armSafety(){
  clearTimeout(safeT);
  safeT = setTimeout(function(){
    if (document.hidden) return;
    if (!ioFired) revealAll(); else revealInView();
  }, 1100);
  clearTimeout(hardT);
  hardT = setTimeout(revealInView, 6000);
}

if (items.length && !REDUCED && window.IntersectionObserver){
  items.forEach(function(e){ e.classList.add("anim"); });
  io = new IntersectionObserver(function(es){
    var k = 0;
    es.forEach(function(e){
      if (!e.isIntersecting) return;
      ioFired = true;
      var t = e.target;
      io.unobserve(t);
      var d = Math.min(k++, 7) * 62;
      if (d) setTimeout(function(){ reveal(t); }, d);
      else reveal(t);
    });
  }, { rootMargin: "0px 0px -7% 0px" });
  items.forEach(function(e){ io.observe(e); });
  armSafety();
  document.addEventListener("visibilitychange", function(){ if (!document.hidden) armSafety(); });
  window.addEventListener("pageshow", function(e){ if (e.persisted) revealInView(); });

  var wrap = $(".page-wrapper"), ticking = false;
  function onScroll(){
    if (ticking) return;
    ticking = true;
    var run = function(){ ticking = false; revealInView(); };
    if (window.requestAnimationFrame) requestAnimationFrame(run); else run();
  }
  window.addEventListener("scroll", onScroll, {passive:true});
  if (wrap) wrap.addEventListener("scroll", onScroll, {passive:true});
}

/* ---- B · LE COMPTEUR SE COMPTE quand la pastille arrive ---- */
var cRAF = 0;
function rollTo(el, from, to){
  if (REDUCED || !window.requestAnimationFrame || !isFinite(from) || from === to){
    el.textContent = String(to); return;
  }
  if (cRAF) cancelAnimationFrame(cRAF);
  var t0 = 0, dur = 640;
  function step(ts){
    if (!t0) t0 = ts;
    var p = (ts - t0) / dur; if (p > 1) p = 1;
    var e = 1 - Math.pow(1 - p, 3);
    el.textContent = String(Math.round(from + (to - from) * e));
    if (p < 1) cRAF = requestAnimationFrame(step);
    else el.textContent = String(to);
  }
  cRAF = requestAnimationFrame(step);
}
var countEl = $("#colCount"), panelEl = $(".chead .panel");
if (countEl && panelEl && !REDUCED){
  var v = parseInt(countEl.getAttribute("data-v"), 10), rolled = false;
  function onLit(){
    if (rolled || !panelEl.classList.contains("lit")) return;
    rolled = true;
    if (isFinite(v)) setTimeout(function(){ rollTo(countEl, 0, v); }, 300);
  }
  if (panelEl.classList.contains("lit")) onLit();
  else if (window.MutationObserver){
    var mo = new MutationObserver(function(){ onLit(); if (rolled) mo.disconnect(); });
    mo.observe(panelEl, { attributes: true, attributeFilter: ["class"] });
    /* plafond : la valeur reelle est dans le HTML, rien ne peut rester a 0 */
    setTimeout(function(){ rolled = true; mo.disconnect(); countEl.textContent = String(v); }, 4000);
  }
}
})();
